import { render, staticRenderFns } from "./ReportTask.vue?vue&type=template&id=51f6381b"
import script from "./ReportTask.vue?vue&type=script&lang=js"
export * from "./ReportTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports